import { t } from 'i18next'

import { ParticipacaoCompradoresGrid } from '@/features/proposta/components/participacao-compradores'
import { CardEtapaContent, CardEtapaItem } from '@/features/proposta/components/ui'
import { useParticipacaoCompradores } from '@/features/proposta/hooks/use-participacao-compradores'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'

type TParticipacaoCompradorContentProps = {
  compradores: TCompradoresCadastrados
}

export const ParticipacaoCompradorContent = ({ compradores }: TParticipacaoCompradorContentProps) => {
  const participacao = useParticipacaoCompradores({
    basePath: 'detalhesDaProposta.participacaoCompradores',
    compradores,
  })

  return (
    <CardEtapaItem
      titulo={t('proposta:detalhes_proposta.participacao_comprador.titulo')}
      descricao={t('proposta:detalhes_proposta.participacao_comprador.descricao')}
      completed={participacao.isCompleted}
    >
      <CardEtapaContent>
        <ParticipacaoCompradoresGrid {...participacao} />
      </CardEtapaContent>
    </CardEtapaItem>
  )
}
